export const handleFormDataChange = (changeValues, isObjectDataFormat, change) => {
  if (isObjectDataFormat) {
    change(changeValues);
  } else {
    Object.keys(changeValues).forEach((propertyName) => {
      change(propertyName, changeValues[propertyName]);
    });
  }
};
